'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchTranslation = exports.isTranslationFetchSucceededAction = undefined;

var _constants = require('./constants');

var isTranslationFetchSucceededAction = exports.isTranslationFetchSucceededAction = function isTranslationFetchSucceededAction(action) {
    return !!action && action.type === _constants.TRANSLATION_FETCH_SUCCEEDED;
};

/**
 * FetchTranslation - translation data action
 * @returns {{type: string}} TRANSLATION_FETCH_REQUESTED action
 */
var fetchTranslation = exports.fetchTranslation = function fetchTranslation() {
    return {
        type: _constants.TRANSLATION_FETCH_REQUESTED
    };
};
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/translation-tokens/dist/main/actions.js
// module id = 270
// module chunks = 0